import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MarkRequestReadState, ReadState, RequestReadState } from '@atlassian/notification-common/types';
import { markBulkApiRoute, markBulkNotificationsFetch } from '../../../../utils/mark-bulk-client';
/**
 * @public
 * Updates the read state of a single notification within a group to the given read state.
 * @param groupId The `id` of the notification group
 * @param notificationId The `id` of the notification within the notification group
 * @param toState The read state the notification should be updated to
 * @param handlers A CallbackHandlers object to handle onSuccess and onError callbacks when the mark requests finish.
 */
export var markGroupNotifications = function markGroupNotifications(groupId, notificationIds, toState, readStateFilter, handlers) {
  return function (_ref) {
    var getState = _ref.getState,
      setState = _ref.setState;
    var groups = getState().groups;
    var groupIndex = groups.findIndex(function (group) {
      return group.id === groupId;
    });
    if (groupIndex === -1) {
      return;
    }
    markBulkNotificationsFetch(notificationIds, toState).then(function (_) {
      return handlers.onSuccess(markBulkApiRoute);
    }).catch(function (e) {
      return handlers.onError(e.code);
    });
    setState({
      groups: groups.reduce(function (newGroups, currentGroup, index) {
        if (index !== groupIndex) {
          newGroups.push(currentGroup);
          return newGroups;
        }

        // Track how many notifications we 'remove' from the group
        // if filtering by unreads only and state is updated to READ.
        var removedCount = 0;
        var updatedGroup = _objectSpread(_objectSpread({}, currentGroup), {}, {
          notifications: currentGroup.notifications.reduce(function (newNotifications, currentNotification) {
            if (!notificationIds.includes(currentNotification.id)) {
              newNotifications.push(currentNotification);
              return newNotifications;
            }
            if (readStateFilter === RequestReadState.UNREAD && toState === MarkRequestReadState.READ) {
              removedCount++;
              return newNotifications;
            }
            newNotifications.push(_objectSpread(_objectSpread({}, currentNotification), {}, {
              readState: toState === MarkRequestReadState.READ ? ReadState.READ : ReadState.UNREAD
            }));
            return newNotifications;
          }, [])
        });
        if (updatedGroup.notifications.length > 0) {
          newGroups.push(_objectSpread(_objectSpread({}, updatedGroup), {}, {
            size: updatedGroup.size - removedCount // Update size based on number of notifications that were 'removed'
          }));
        }
        return newGroups;
      }, [])
    });
  };
};